import { ShieldCheck } from "lucide-react";
import { ChapterTag, MaskedLines, FadeUp } from "./Reveal";
import { BookButton } from "./CTA";

export const Guarantee = () => (
  <section id="guarantee" data-testid="guarantee-section" className="py-24 lg:py-36 bg-wine text-ivory grain relative overflow-hidden scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 relative">
      <ChapterTag index="06" label="Our Guarantee" dark />
      <div className="grid lg:grid-cols-12 gap-12 mt-10 items-center">
        <div className="lg:col-span-8">
          <h2 data-testid="guarantee-headline" className="font-display font-semibold tracking-tight leading-[0.98] text-5xl sm:text-6xl lg:text-7xl">
            <MaskedLines lines={[<span className="text-gold">100%</span>, <>Solution Guaranteed<span className="text-gold align-super text-[0.5em]">*</span></>]} />
          </h2>
          <FadeUp delay={0.35} className="mt-8 max-w-xl">
            <p className="text-ivory/75 leading-relaxed">
              We stand behind the treatment we provide. If the agreed pest problem is not resolved within the applicable guarantee terms, we will continue working according to our guarantee policy.
            </p>
            <p className="text-ivory/45 text-xs mt-4 leading-relaxed">
              *Terms and conditions apply. The exact guarantee terms are shared with you in writing before treatment begins. <span className="italic">[Editable placeholder — final guarantee wording to be supplied by the business.]</span>
            </p>
          </FadeUp>
          <FadeUp delay={0.5} className="mt-10">
            <BookButton testid="guarantee-book-btn" light />
          </FadeUp>
        </div>
        <FadeUp delay={0.4} className="lg:col-span-4 flex lg:justify-end">
          <div className="border border-gold/40 p-10 lg:p-12 text-center max-w-xs">
            <ShieldCheck className="h-10 w-10 text-gold mx-auto mb-5" strokeWidth={1.25} />
            <p className="font-display text-2xl font-medium leading-snug">"We don't consider the job done until the problem is."</p>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
